// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 826) return "static/chunks/826.affe0987fe6a1a7e.js";
	if (chunkId === 46) return "static/chunks/46.344a007cc04bc326.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"431":"29564a12b8cca8e4","484":"c3aaa499d97a27c1","828":"dcaed778edc0664c","939":"70969a5b78fae348"}[chunkId] + ".js";
};